module.exports = __webpack_public_path__ + "img/vip_addcustomer_icon.a89acfbf.png";